
import api from 'frontend/api';

import { canSelectOption, fractionalSizeOptions } from '../options';
import state from './state';

export default {
	async fetchProductInfo({ commit }, params)
	{
		// fetch product data from server
		var result = await api.get(`/products/${params.slug}`);

		// set product & optionsinfo
		commit('setProductInfo', result.data.product);
		commit('setOptionList', result.data.options);
	},

	// clean selections if the cart item parameters change to filter out any options that should not be selectable
	filterSelectableOptions({ state, getters })
	{
		var width = parseInt(state.cartItem.width.whole, 10) || 0; //+ parseFloat(this.cartItem.width.fractional);
		var height = parseInt(state.cartItem.height.whole, 10) || 0; // + parseFloat(this.cartItem.height.fractional);
		var updated = {};

		// currently selected options
		var selected = [ ...getters.allSelectedOptions ];
		
		for(var typeId in state.optionSelections)
		{
			// create copy of selections for this option type
			var current = state.optionSelections[typeId].slice();
			var filtered = [], pos;

			// filter out un-selectable options
			for(var id of current)
			{
				if (canSelectOption(state.options[id], width, height, selected))
					filtered.push(id);
				else if ((pos = selected.indexOf(id)) >= 0)
					selected.splice(pos);
			}

			//current = current.filter(id => canSelectOption(state.options[id], width, height, getters.allSelectedOptions));
			
			// update new selections
			updated[typeId] = filtered;
		}

		// update selection state
		state.optionSelections = updated;
	},

	selectOption({ commit, dispatch }, params)
	{
		commit('addSelectedOption', params);
		//dispatch('filterSelectableOptions');
	},

	deselectOption({ commit, dispatch }, params)
	{
		commit('removeSelectedOption', params);
		//dispatch('filterSelectableOptions');
	},

	async fetchSummary({ state, commit, getters })
	{
		var params = {
			product_id: state.product.id,
			qty: state.cartItem.qty,
			//headrails: state.headrailNum,
			options: getters.allSelectedOptions,
		};

		params.width = Math.ceil(parseFloat(state.cartItem.width.whole) + fractionalSizeOptions[state.cartItem.width.fractional]);
		params.height = Math.ceil(parseFloat(state.cartItem.height.whole) + fractionalSizeOptions[state.cartItem.height.fractional]);

		commit('setLoadingIndicator', { key: 'summary', status: true });

		try
		{
			var result = await api.get('/custom_product_summary', { params });
			commit('updateSummary', result.data.summary);
		}
		finally
		{
			commit('setLoadingIndicator', { key: 'summary', status: false });
		}
	},

	async addItemToCart({ state, getters })
	{
		var item = {
			item_type: 'product',
			product_id: state.product.id,
			room: state.cartItem.room,
			width_whole: state.cartItem.width.whole,
			width_fractional: state.cartItem.width.fractional,
			height_whole: state.cartItem.height.whole,
			height_fractional: state.cartItem.height.fractional,
			qty: state.cartItem.qty,
			options: getters.allSelectedOptions,
			mount_pos: state.cartItem.mountPos,
			//*headrail_count: state.headrailNum,
			headrail_controls: state.headrailControls,
			/*headrail_sizes: state.headrailSizes.map(size => {
				var w = parseFloat(size.whole) || 0;
				var f = fractionalSizeOptions[size.fractional];
				return w + f;
			})*/
		};

		await api.post('/cart', { item });
	}
}